import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { InAppService } from "../../services/in-app-service/in-app-service";

@IonicPage()
@Component({
  selector: 'page-welcome-in-app',
  templateUrl: 'welcome-in-app.html',
})
export class WelcomeInAppPage {

  private id: string;
  public title: string;
  public content: string;
  public backgroundUrl: string;

  constructor(private navCtrl: NavController, private navParams: NavParams, private inAppService: InAppService) {
    this.id = this.navParams.data.id;
    this.title = this.navParams.data.title;
    this.content = this.navParams.data.content;
    this.backgroundUrl = this.navParams.data.backgroundUrl;
  }

  public close() {
    this.inAppService.markInAppAsDisplayed(this.id);
    this.navCtrl.pop();
  }
}



// WEBPACK FOOTER //
// ./src/modules/core/pages/welcome-in-app/welcome-in-app.ts